var renderingErrorHandler = (function() {
	var $template = $('#rendering-failure-template');

	var renderError = function(app) {
		var $error = $($template.html());

		$error.find('.app-id').text(app.id);
		$error.find('.details').text(app.statusMessage);
		return $error;
	};

	var showErrorIfFailed = function(apps) {
		apps.forEach(function(app) {
			switch (app.status && app.status.toUpperCase()) {
				case 'RENDERING_FAILURE':
					var $appContainer = $('.' + app.id);
					var $error = renderError(app);
					$appContainer.html($error);
					break;
			}
		});
	};

	return {
		showErrorIfFailed: showErrorIfFailed
	};
})();
